import { render, staticRenderFns } from "./TheSoftPhone.vue?vue&type=template&id=015918d4&scoped=true"
import script from "./TheSoftPhone.vue?vue&type=script&lang=js"
export * from "./TheSoftPhone.vue?vue&type=script&lang=js"
import style0 from "./TheSoftPhone.vue?vue&type=style&index=0&id=015918d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015918d4",
  null
  
)

export default component.exports